export const numberOnly = {
    beforeMount: (el) => {
        el.addEventListener('keypress', (e) => {
            let keyCode = (e.keyCode ? e.keyCode : e.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                e.preventDefault();
            }
        })
    }
}